import { CARDROP_STATES_CAMPAIGN, CARDROP_CAMPAIGN } from "./endpoints";

export const contestStates = async (userId?: string) => {
    try {
        
        if(!userId){
            console.error('[Contest Service] User ID is not available.');
            return null;
        }
        
        const response = await fetch(CARDROP_STATES_CAMPAIGN, {
            method: 'GET',
            headers : {
                'x-auth-user-id' : userId
            }
        });
    
        if (!response.ok) {
            console.error(`[Contest Service] HTTP error! Status: ${response.status}`);
            return null;
        }

        const data = await response.text();

        return data;

    } catch (error) {
        console.error('[Contest Service] Error while fetching Contest data:', error);
        return null;
    }
}

export const allCampaign = async () => {
  try {
    const response = await fetch(CARDROP_CAMPAIGN, {
      method: 'GET',
    });

    if (!response.ok) {
      console.error(`[Contest Service] HTTP error! Status: ${response.status}`);
      return { activeCampaign: null, upcomingCampaign: null };
    }

    const data = await response.json();

    return data;

  } catch (error) {
    console.error('[Contest Service] Error while fetching Contest data:', error);
    return { activeCampaign: null, upcomingCampaign: null };
  }
};

export const hasParticipated = async (userId?: any , campaignId?: any) => {
  try {

    if(!userId){
        console.error('[Contest Service] User ID is not available.');
        return null;
    }

    const response = await fetch(`${CARDROP_CAMPAIGN}/participated/${campaignId}`, {
      method: 'GET',
      headers : {
          'x-auth-user-id' : userId
      }
    });

    if (!response.ok) {
      console.error(`[Contest Service] HTTP error! Status: ${response.status}`);
      return null;
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error('[Contest Service] Error while fetching has participated data:', error);
    return null;
  }
};

export const getCampaignOptIn = async (campaignId?: number, userID?: string) => {
  try {

    if(!campaignId || !userID){
      console.error(`campaignId or userID missing in Contest Opt In`);
      return null;
    }

    const response = await fetch(`${process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE}/campaign/consent/${campaignId}`, {
      method: 'GET',
      headers : {
        'Content-Type': 'application/json',
        'x-auth-user-id' : userID
      }
    });

    if (!response.ok) {
      console.error(`[Contest Service] HTTP error! Status: ${response.status}`);
      return null;
    }

    const data = await response.json();

    return data;

  } catch (error) {
    console.error('[Contest Service] Error while fetching Contest Opt In:', error);
    return null;
  }
};

export const postCampaignOptIn = async (campaignId?: number, userID?: string) => {
  try {

    if(!campaignId || !userID){
      console.error(`campaignId or userID missing in Contest Opt In`);
      return null;
    }

    const response = await fetch(`${process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE}/campaign/${campaignId}/participants/opt-in`, {
      method: 'POST',
      headers : {
        'Content-Type': 'application/json',
        'x-auth-user-id' : userID
      }
    });

    if (!response.ok) {
      console.error(`[Contest Service] HTTP error! Status: ${response.status}`);
      return { activeCampaign: null, upcomingCampaign: null };
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error('[Contest Service] Error while marking opt in:', error);
    return { activeCampaign: null, upcomingCampaign: null };
  }
};